var map = {
	"./image1.svg": "dd49",
	"./image2.svg": "10b2",
	"./image3.svg": "ac39",
	"./image4.svg": "a7e5",
	"./image5.svg": "a16a",
	"./image6.svg": "b028"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "72a8";